module.exports = __webpack_public_path__ + "static/media/22ESCWA15.23e3e793.jpg";